import React, { useCallback } from "react";

import AppLayout from "../common/AppLayout";
import UsersList from "./components/UsersList";
import AddUserDialog from "./components/AddUserDialog";

export default function UsersView() {
  const [openAddUserDialog, setOpenAddUserDialog] = React.useState(false);

  // Handlers for opening and closing the dialog
  const openDialog = useCallback(() => setOpenAddUserDialog(true), []);
  const closeDialog = useCallback(() => setOpenAddUserDialog(false), []);

  return (
    <AppLayout pageName="Users" maxWidth={false}>
      <AddUserDialog open={openAddUserDialog} handleClose={closeDialog} />
      <UsersList handleOpenAddUserDialog={openDialog} />
    </AppLayout>
  );
}
